import request from '../utils/request';

export const createOrder = (order) => {
  return request({
    url: '/jade-identification-order',
    method: 'post',
    data: order
  });
};

export const updateOrder = (order) => {
  return request({
    url: '/jade-identification-order',
    method: 'put',
    data: order
  });
};

export const deleteOrder = (orderId) => {
  return request({
    url: `/jade-identification-order/${orderId}`,
    method: 'delete'
  });
};

export const pageOrders = (queryDTO) => {
  return request({
    url: '/jade-identification-order/page',
    method: 'post',
    data: queryDTO
  });
};

export const getOrderDetail = (orderId) => {
  return request({
    url: `/jade-identification-order/${orderId}`,
    method: 'get'
  });
};

export const getOrderByOrderNo = (orderNo) => {
  return request({
    url: `/jade-identification-order/order-no/${orderNo}`,
    method: 'get'
  });
};

export const updateOrderResult = (orderId, result) => {
  return request({
    url: `/jade-identification-order/${orderId}/result`,
    method: 'put',
    data: { result }
  });
};

export const updateOrderStatus = (orderId, status) => {
  return request({
    url: `/jade-identification-order/${orderId}/status`,
    method: 'put',
    data: { status }
  });
};

export const updatePayStatus = (orderId, payStatus) => {
  return request({
    url: `/jade-identification-order/${orderId}/pay-status`,
    method: 'put',
    data: { payStatus }
  });
};